import React from 'react'

import { Container } from '@material-ui/core'

import translate from '~/locale'

import SectionSubtitle from '../SectionSubtitle'
import SectionTitle from '../SectionTitle'
import WhatWeDoCards from '../WhatWeDoCards'

const BringCommunityTogether: React.FC = () => {
  return (
    <div className="bg-white">
      <Container className="pt-1 pb-6">
        <SectionTitle>{translate('bringing_communitiy_together')}</SectionTitle>
        <SectionSubtitle>{translate('cities_are_the_sum')}</SectionSubtitle>
        <WhatWeDoCards />
      </Container>
    </div>
  )
}

export default BringCommunityTogether
